import { render, staticRenderFns } from "./ChannelsChat.vue?vue&type=template&id=0af05882"
import script from "./ChannelsChat.vue?vue&type=script&lang=js"
export * from "./ChannelsChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports